export const ROUTE_WELCOME = 'welcome';
export const ROUTE_FORM = 'form';
export const ROUTE_INTRO = 'intro';
export const ROUTE_INSTRUCTION_SLIDER = 'instruction1';
export const ROUTE_INSTRUCTION_NAVIGATION = 'instruction2';
export const ROUTE_READY = 'ready';



// WEBPACK FOOTER //
// ./src/containers/start/RouteList.ts